import React from 'react';
import '../applications-css/Application.css';
import "../applications-css/Pathfinder.css";

class Pathfinder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 10,
      width: 10,
      actualBoard: [],
      startLoc: [-1, -1],
      endLoc: [-1, -1],
      currentMode: 'start',
      foundPath: [],
      pathDisplayed: false,
    }
    this.cellClickHandler = this.cellClickHandler.bind(this);
  }

  componentDidMount() {
    let array = [];
    this.create2dBoard(array);
    this.setState({
      spacesRemaining: this.state.height * this.state.width,
      actualBoard: array
    },
    function() {
          console.log(this.state.actualBoard)
    });
  }

  create2dBoard(array) {
    for(let i = 0; i < this.state.width; i++) {
      let newRow = new Array(this.state.height);
      for(let j = 0; j < this.state.height; j++) {
        newRow[j] = {
          characterValue: "",
          isClosed: false,
          isOpen: false,
          parent: [-1, -1],
          x: i,
          y: j,
          f: 0,
          g: 0,
          h: 0
        }
      }
      array.push(newRow);
    }
  }

  modeHandler(mode) {
    let startButton = this.refs.startButton;
    let endButton = this.refs.endButton;
    let wallButton = this.refs.wallButton;
    let solveButton = this.refs.solveButton;
    startButton.setAttribute("class", "unclickedButton");
    endButton.setAttribute("class", "unclickedButton");
    wallButton.setAttribute("class", "unclickedButton");
    solveButton.setAttribute("class", "unclickedButton");
    if(mode === "start") {
      startButton.setAttribute("class", "clickedButton");
    }
    else if(mode === "end") {
      endButton.setAttribute("class", "clickedButton");
    }
    else if(mode === "walls"){
      wallButton.setAttribute("class", "clickedButton");
    }
    else {
      solveButton.setAttribute("class", "clickedButton");
    }
    this.setState({
      currentMode: mode
    })
  }

  wallClickHandler(x, y) {
    let newBoard = this.state.actualBoard;
    let newValue = "W";
    if(newBoard[x][y].characterValue === 'W') {
      newValue = ""
    }
    newBoard[x][y].characterValue = newValue;
    this.setState({
      actualBoard: newBoard,
    })
  }

  startClickHandler(x, y) {
    let newBoard = this.state.actualBoard;
    if(this.state.startLoc[0] !== -1) {
      // clear old one
      let oldX = this.state.startLoc[0];
      let oldY = this.state.startLoc[1];
      newBoard[oldX][oldY].characterValue = " ";
    }
    newBoard[x][y].characterValue = "S";
    this.setState({
      actualBoard: newBoard,
      startLoc: [x, y]
    })
  }

  endClickHandler(x, y) {
    let newBoard = this.state.actualBoard;
    if(this.state.endLoc[0] !== -1) {
      // clear old one
      let oldX = this.state.endLoc[0];
      let oldY = this.state.endLoc[1];
      newBoard[oldX][oldY].characterValue = " ";
    }
    newBoard[x][y].characterValue = "E";
    this.setState({
      actualBoard: newBoard,
      endLoc: [x, y]
    })
  }

  cellClickHandler(location) {
    let x = location[0];
    let y = location[1];
    if(this.state.pathDisplayed === true) {
      this.clearPath();
    }
    if(this.state.currentMode === 'walls') {
      this.wallClickHandler(x, y);
    }
    else if(this.state.currentMode === 'start') {
      this.startClickHandler(x, y);
    }
    else if(this.state.currentMode === 'end') {
      this.endClickHandler(x, y);
    }
  }

  clearPath() {
    let tempPath = this.state.foundPath;
    let tempBoard = this.state.actualBoard;
    for(let i = 1; i < tempPath.length - 1; i++) {
      let x = tempPath[i].x;
      let y = tempPath[i].y;
      tempBoard[x][y].characterValue = " "
    }
    this.setState({
      foundPath: [],
      actualBoard: tempBoard,
      pathDisplayed: false
    })
  }

  badInputHandler() {
    return(
      <span>
        <img width="32px" src={this.props.warning_icon} draggable="false" alt={"Info"}/>
        <p> You need both a start and an end position. </p>
      </span>
    );
  }

  noPathFoundHandler() {
    return(
      <span>
        <img width="32" src={this.props.warning_icon} draggable="false" alt={"Info"}/>
        <p> No path was found with the current wall layout. </p>
      </span>
    );
  }

  attemptToSolve() {
    if(this.state.startLoc[0] === -1 || this.state.endLoc[0] === -1) {
      this.props.appLauncherHandler(null, "Popup Window", this.badInputHandler);
      console.log("bad input")
      return;
    }

    // tempPath is a list of spaces, not coordinates
    let tempPath = this.calculatePath();

    if(tempPath.length === 0) {
      this.props.appLauncherHandler(null, "Popup Window", this.noPathFoundHandler);
      console.log("error")
    }

    // else fill in the path
    let tempBoard = this.state.actualBoard;
    for(let i = 1; i < tempPath.length - 1; i++) {
      let x = tempPath[i].x;
      let y = tempPath[i].y;
      tempBoard[x][y].characterValue = "○"
    }

    this.setState({
      foundPath: tempPath,
      actualBoard: tempBoard,
      pathDisplayed: true
    })
  }

  calculatePath() {
    let tempBoard = this.state.actualBoard;
    let openList = [];
    let closedList = [];
    let x = this.state.startLoc[0];
    let y = this.state.startLoc[1];
    tempBoard[x][y].g = 0;
    openList.push(tempBoard[x][y])

    while(openList.length > 0) {
      // find current square (square with smallest f on openList)
      let smallestF = openList[0];
      for(let i = 0; i < openList.length; i++) {
        if(openList[i].f < smallestF.f) {
          smallestF = openList[i]
        }
      }

      // remove current square from openList, add to closedList
      let smallestIndex = openList.indexOf(smallestF);
      openList.splice(smallestIndex, 1);
      closedList.push(smallestF);

      // if current square = goal
        // backtrack to get path
      if(smallestF.x === this.state.endLoc[0] && smallestF.y === this.state.endLoc[1]) {
        break;
      }
      // else, find the children
      else {
        x = smallestF.x;
        y = smallestF.y;
        let surroundingSpaces = [
          [x - 1, y - 1], [x - 1, y], [x - 1, y + 1],
          [x, y - 1], [x, y + 1],
          [x + 1, y - 1], [x + 1, y], [x + 1, y + 1]
        ]
        for(let i = 0; i < surroundingSpaces.length; i++) {
          let newX = surroundingSpaces[i][0];
          let newY = surroundingSpaces[i][1];

          // if invalid, continue
          if(this.isValidSpace(newX, newY) === false || this.isValidDiagonal(x, y, newX, newY) === false) {
            continue;
          }

          // if on closedList or is wall, continue
          let squareToCheck = tempBoard[newX][newY];
          let closedIndex = closedList.indexOf(squareToCheck); // if not -1, is on closedList
          if(closedIndex !== -1 || squareToCheck.characterValue === 'W') {
            continue;
          }

          let openIndex = openList.indexOf(squareToCheck);
          if(openIndex === -1) { // if not already on the openList, use this for g
            openList.push(tempBoard[newX][newY]);
            squareToCheck.g = smallestF.g + this.distanceBetween(smallestF, squareToCheck);
            squareToCheck.parent = smallestF;
          }
          else {  // else we have to check if it's smaller
            let oldGValue = openList[openIndex].g
            let newGValue = smallestF.g + this.distanceBetween(smallestF, squareToCheck);
            if(newGValue < oldGValue) {
              squareToCheck.g = newGValue;
              squareToCheck.parent = smallestF;
            }
          }
          squareToCheck.h = this.distanceBetween(squareToCheck, tempBoard[this.state.endLoc[0]][this.state.endLoc[1]]);
          squareToCheck.f = squareToCheck.g + squareToCheck.h;
        }
      }
    }
    if(openList.length === 0) {
      return [];
    }

    let tempPath = [];
    // get the result
    let currentCell = tempBoard[this.state.endLoc[0]][this.state.endLoc[1]];
    while(currentCell.x !== this.state.startLoc[0] || currentCell.y !== this.state.startLoc[1]) {
      // console.log("   " + currentCell.x + ", " + currentCell.y)
      tempPath.push(currentCell)
      currentCell = tempBoard[currentCell.parent.x][currentCell.parent.y];

    }
    // console.log("   " + currentCell.x + ", " + currentCell.y)
    tempPath.push(currentCell)
    return tempPath
  }

  distanceBetween(square1, square2) {
    let diffX = Math.abs(square1.x - square2.x);
    let diffY = Math.abs(square1.y - square2.y);
    return Math.sqrt((diffX * diffX) + (diffY * diffY))
  }

  isValidSpace(x, y) {
    if(x > this.state.width - 1 || y > this.state.height - 1) {
      return false;
    }
    if(x < 0 || y < 0) {
      return false;
    }
    return true;
  }

  isValidDiagonal(x, y, newX, newY) {
    let tempBoard = this.state.actualBoard;
    if(newX === x || newY === y) {
      return true;
    }
    if(newX === x - 1 && newY === y - 1) {
      if(tempBoard[x-1][y].characterValue === 'W' && tempBoard[x][y - 1].characterValue === 'W') {
        return false;
      }
    }
    if(newX === x - 1 && newY === y + 1) {
      if(tempBoard[x-1][y].characterValue === 'W' && tempBoard[x][y + 1].characterValue === 'W') {
        return false;
      }
    }
    if(newX === x + 1 && newY === y - 1) {
      if(tempBoard[x][y - 1].characterValue === 'W' && tempBoard[x + 1][y].characterValue === 'W') {
        return false;
      }
    }
    if(newX === x + 1 && newY === y + 1) {
      if(tempBoard[x+1][y].characterValue === 'W' && tempBoard[x][y + 1].characterValue === 'W') {
        return false;
      }
    }
    return true;
  }

  createBoard() {
    let cellClickHandler = this.cellClickHandler;
    return(
      <div id="pathfinderGrid">
      {this.state.actualBoard.map(function(row, xIndex) {
        return row.map(function(cell, yIndex) {
          return(
            <PathfinderSquare
              location={[xIndex, yIndex]}
              currentValue={cell.characterValue}
              cellClickHandler = {cellClickHandler}
              key={[xIndex, yIndex]}/>
          );
        })
      })}
      </div>
    )
  }
  render() {
    return(
      <div id="pathfinderWrapper" className="outsideWrapper">
        <div id="pathfinderHeader">
          <button className="unclickedButton" ref="startButton"
            onClick = {() => this.modeHandler("start")}>
              Starting Location
          </button>
          <button className="unclickedButton" ref="endButton"
            onClick = {() => this.modeHandler("end")}>
              Ending Location
          </button>
          <button className="unclickedButton" ref="wallButton"
            onClick = {() => this.modeHandler("walls")}>
              Add/Remove Wall
          </button>
          <button className="unclickedButton" ref="solveButton"
            onClick = {() => this.attemptToSolve()}>
              SOLVE
          </button>
        </div>
          {this.createBoard()}
      </div>
    )
  }
}

class PathfinderSquare extends React.Component {
  constructor(props) {
    super(props);

    this.clickHandler = this.clickHandler.bind(this);
  }

  clickHandler(location) {
    this.props.cellClickHandler(location);
  }

  setColor(currentView) {
    let button = this.refs.pathfinderButton;
    if(currentView === 'W') {
      button.setAttribute("class", "clickedButton");
    }
    else {
      button.setAttribute("class", "unclickedButton");
    }
  }

  showButtonClicked() {
    let button = this.refs.pathfinderButton;
    button.setAttribute("class", "clickedButton");
  }

  showButtonUnclicked() {
    let button = this.refs.pathfinderButton;
    button.setAttribute("class", "unclickedButton");
  }

  render() {
    let pointerEvents = "auto";
    let attribute = "unclickedButton"
    let currentView = this.props.currentValue;
    if(currentView === "W") {
      attribute = "clickedButton"
    }
    return(
      <div id="pathfinderCell">
        <button className={attribute} ref="pathfinderButton"
          onClick = {() => this.clickHandler(this.props.location)}
          style={{
            pointerEvents: pointerEvents,
            fontWeight: "bold"
          }}
        >
          {currentView}
        </button>
      </div>
    )
  }
}

export default Pathfinder;
